import React from 'react';
import './App.css';
import Login from './Components/Login/Login';
import { Switch, Route, BrowserRouter } from 'react-router-dom';
import WithAuthentication from './Components/Authentication/Authentication';
import ErrorMessage from './Components/ErrorPage/ErrorPage';
import ProtectedRoute from './Components/ProtectedRoute/ProtectedRoute';
import Dashboard from "./Components/Dashboard/Dashboard";
import AddRequests from "./Components/Requests/Add/AddRequests";
import ListRequests from "./Components/Requests/List/List";
import Spending from "./Components/Requests/Spending/Spending";
import PasswordReset from "./Components/PasswordReset/PasswordReset";
import PasswordConfirm from './Components/PasswordConfirm/PasswordConfirm';


const App = (props) => {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/" render={() =>
          <Login {...props} />
        } />
        <ProtectedRoute path="/dashboard" component={Dashboard} {...props} />
        <ProtectedRoute path="/request/add" component={AddRequests} {...props} />
        <ProtectedRoute path="/request/list" component={ListRequests} {...props} />
        <ProtectedRoute path="/request/material/spending" component={Spending} {...props} />
        <Route exact path="/reset-password/confirm" component={PasswordConfirm} {...props} />
        <Route path="/reset-password" component={PasswordReset} {...props} />
        <Route exact path="*" render={() =>
          <ErrorMessage message="Page not found." errorCode="404" />
        } />
      </Switch>
    </BrowserRouter>
  );
};

export default WithAuthentication(App);


// WEBPACK FOOTER //
// ./src/App.js